module.exports = __webpack_public_path__ + "static/images/jf-coupon-bg.7ab1807.png";